module.exports = __webpack_public_path__ + "49d8cf9d0514462c4311f167700831ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/valorant/split.png
// module id = 446
// module chunks = 0